import { render, staticRenderFns } from "./AdditionalInfo.vue?vue&type=template&id=2f5acd7e&"
import script from "./AdditionalInfo.vue?vue&type=script&lang=js&"
export * from "./AdditionalInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports